import styled from 'styled-components';
import BottomModal from '../../modal/BottomModal';
import { useState } from 'react';

type Membership = '무료 체험' | '스탠다드' | '프리미엄';

interface Props {
  select: Membership;
  other: Membership;
  changeSelect: (select: Membership) => void;
  onClose: () => void;
}

const plans = ['무료 체험', '스탠다드', '프리미엄'] as Membership[];

function ComparePlanSelectModal({
  select,
  other,
  changeSelect,
  onClose,
}: Props) {
  const [selectMembership, setSelectMembership] = useState(select);

  const getStatus = (plan: Membership) => {
    if (plan === selectMembership) {
      return 'selected';
    }
    if (plan === other) {
      return 'disabled';
    }
    return 'default';
  };
  return (
    <BottomModal onClose={onClose}>
      <Header>
        <Spacer />
        <Title>비교할 요금제 선택</Title>
        <img
          src="/assets/images/close/close-dark-gray.svg"
          alt="닫기"
          width={24}
          onClick={onClose}
        />
      </Header>
      <Content>
        {plans.map((plan) => (
          <Item
            key={plan}
            onClick={() => {
              if (plan === other) return;
              setSelectMembership(plan);
            }}
          >
            <ItemContent $status={getStatus(plan)}>{plan}</ItemContent>
            {getStatus(plan) === 'selected' && (
              <img src="/assets/images/check/check-purple.svg" alt="select" />
            )}
            {getStatus(plan) === 'disabled' && (
              <img
                src="/assets/images/check/check-purple-disabled.svg"
                alt="disable"
              />
            )}
          </Item>
        ))}
      </Content>
      <ButtonContainer>
        <CancleButton onClick={onClose}>취소</CancleButton>
        <ConfirmButton
          onClick={() => {
            changeSelect(selectMembership);
            onClose();
          }}
        >
          비교하기
        </ConfirmButton>
      </ButtonContainer>
    </BottomModal>
  );
}

export default ComparePlanSelectModal;

const Header = styled.div`
  display: flex;
  height: 56px;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const Spacer = styled.div`
  width: 24px;
`;

const Title = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const Content = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const Item = styled.div`
  display: flex;
  padding: 8px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  & > img {
    width: 24px;
    height: 24px;
  }
`;

const ItemContent = styled.div<{
  $status?: 'selected' | 'disabled' | 'default';
}>`
  flex: 1 0 0;
  color: ${({ $status }) =>
    $status === 'selected'
      ? '#4228d6'
      : $status === 'disabled'
        ? '#C7C4FF'
        : '#616161'};

  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const ButtonContainer = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-top: 1px solid rgba(112, 115, 124, 0.22);
  background: #fff;
`;

const Button = styled.button`
  display: flex;
  padding: 14px 28px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: none;
  outline: none;

  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const CancleButton = styled(Button)`
  background: rgba(112, 115, 124, 0.08);
  color: #616161;
`;

const ConfirmButton = styled(Button)`
  background: #4228d6;
  font-weight: 700;
  color: #fff;
  flex: 1 0 0;
`;
